<div *ngIf="this.isLoading" class="se-loader"></div>
<div class=" col-lg-12 col-md-12 col-sm-12 ">
  <div class="exptop-div col-lg-12 col-md-12 col-sm-12">
    <div class="export-div">
      {{labels.menuExport | translate}}
    </div>

  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 mid-div">
    <div class="input-group">
      <div class="col-lg-4 col-md-4 col-sm-4">
        <div class="row input-title">
          {{labels.selectStartDate | translate}}
        </div>

        <div class="row">
          <p-calendar name="frmDate" ngDefaultControl [inputStyle]="{'width':'250px','height':'35px','color':'#434343','border-top-style':'none','line-height':'85px','border-radius':'0px','border-left-style':'none','border-right-style':'none','border-color':'#7d7d7d','font-family':'Nunito','font-size':'16px','border-width':'initial'}"
                      [(ngModel)]="startDate" dateFormat="dd-MM-yy" [maxDate]="today" [showIcon]="true"
                      appendTo="body" readonlyInput="true" showButtonBar="true"
                      placeholder="{{labels.fromdate|translate}}" (onSelect)="checkRange()">

          </p-calendar>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-6">
        <div class="row input-title">
          {{labels.selectEndDate |translate}}
        </div>

        <div class="row">
          <p-calendar name="startDt" ngDefaultControl [inputStyle]="{'width':'250px','height':'35px','color':'#434343','border-top-style':'none','line-height':'85px','border-radius':'0px','border-left-style':'none','border-right-style':'none','border-color':'#7d7d7d','font-family':'Nunito','font-size':'16px','border-width':'initial'}"
                      appendTo="body" readonlyInput="true" showButtonBar="true" [(ngModel)]="endDate" dateFormat="dd-MM-yy"
                      [minDate]="startDate" [maxDate]="maxDateValue" [showIcon]="true" placeholder="{{labels.todate|translate}}" (onSelect)="checkRange()">

          </p-calendar>

        </div>
      </div>
    </div>
    <div class="list-clr col-lg-4 col-md-4 col-sm-6">
      <div class="input-title">
        {{labels.dgCreateSelectDevices | translate}}
      </div>
      <p-multiSelect ngDefaultControl class="input-content-drp height35px" (onChange)="CoolerNameSelectionChanged($event)" [options]="coolersList" [(ngModel)]="coolerNames"
                     (placeholder)="labels.dgCreateSelectDevices" optionValue="key" optionLabel="value" display="chip"></p-multiSelect>
    </div>
    <hr class="pageBreak">

    <div class="col-lg-4 col-md-4 col-sm-6 format-icon">
      <label class="formatLabel">{{labels.format|translate}}</label><br>
      <div>
        &nbsp;&nbsp;<img width="134px" height="150px" alt="se logo" class="se-logo se-logo-img lg-json" src='assets/json.svg' />&nbsp;&nbsp;
      </div>
    </div>
  </div>
  <!--<div class="bottom-div col-lg-12 col-md-12 col-sm-12">
    <button class="se-button btn-export" (click)="getDLFCountV2()">
      
    </button>
  </div>-->
  <div class="qds-controls qds-related col-lg-12 col-md-12 col-sm-12">
    <qds-button importance="emphasized" text="{{labels.menuExport | translate}}"></qds-button>
    </div>
  </div>

  <div class="se-dialog" *ngIf="showWarningmodal">
    <div class="se-dialog-holder">
      <div class="se-complex-header se-warning">
        <h3 class="se-dialiog-title"> Warning! You are about to download {{this.totalFiles}} file(s) for {{this.size}}.</h3>
      </div>
      <div class="se-dialog-body se-dialog-body-delete">
        <div *ngIf="this.isLoading" class="se-loader"></div>
        {{this.labels.aggreeWarn | translate}}

      </div>
      <div class="se-dialog-footer">
        <button class="se-button" (click)="close()">{{labels.no | translate}}</button>
        <button class="se-button" (click)="ExportJSONV2()">{{labels.yes | translate}}</button>
      </div>

    </div>
  </div>

  <template ngbModalContainer>
  </template>
  <p-toast class="mt10" position="top-center" key="success"></p-toast>
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <p-toast position="center" key="c" (onClose)="onReject()" [baseZIndex]="5000">

  </p-toast>

  <ng-template #ProgressContent>
    <div class="headerdiv">
      <div class="row update-rules-details">
        {{contentHeader| translate}}
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
      <!--<div class="closeRuleIcon">
        <img width="36px" height="37px" alt="close" src="assets/rule-close.svg" (click)="rejectmd()" class="cursorPointerHand"
             (keypress)="rejectmd()" (keydown)="rejectmd()" (keyup)="rejectmd()" />
      </div>-->
    </div>
    <div>
      <div class="content-master">

        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow={currentPercentage} aria-valuemin="0" aria-valuemax={totalFiles} [ngStyle]="{ 'width': currentPercentage + '%' }">{{downloadedFiles}}/{{totalFiles}}</div>
        </div>
      </div>
      <label class="lbl-info">{{downloadedFiles}} file(s) downloaded out of {{totalFiles}} file(s).</label>
      <hr class="cancelSectionBorder">
      <div class="div-sec">
        <button class="btn-cancel cursorPointerHand" (click)="rejectmd()">{{labels.cancel | translate}}</button>
      </div>
    </div>
  </ng-template>

  <div class="se-dialog" *ngIf="Progress_dailog">
    <div class="se-dialog-holder">
      <div class="se-complex-header">
        <h3 class="se-dialiog-title">
          {{contentHeader| translate}}
          <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </h3>
      </div>
      <div class="se-dialog-body">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow={currentPercentage} aria-valuemin="0" aria-valuemax={totalFiles} [ngStyle]="{ 'width': currentPercentage + '%' }">{{downloadedFiles}}/{{totalFiles}}</div>
        </div>
        <label class="lbl-info">{{downloadedFiles}} file(s) downloaded out of {{totalFiles}} file(s).</label>
      </div>
      <!--<div class="se-dialog-footer">
        <button class="se-button" (click)="rejectmd()">{{labels.cancel | translate}}</button>
      </div>-->
    </div>
  </div>